module.exports = {
    SERVER_DOMAIN: {
        VIDEO_PLAYER_DOMAIN: "https://web-public-viewer-video-dev.wjthinkbig.com",
        // PDF_VIEWER_DOMAIN: "https://web-public-viewer-pdf-dev.wjthinkbig.com",
        PDF_VIEWER_DOMAIN: "https://smartall-m.wjthinkbig.com",
        // QST_VIEWER_DOMAIN: "https://tqs-dev.wjthinkbig.com",
        // QST_VIEWER_DOMAIN: "https://tqs.wjthinkbig.com",
        QST_VIEWER_DOMAIN: "https://smartall-m.wjthinkbig.com",
        GW_SMARTALL_MID_DOMAIN: "http://gw-smartall-mid-dev.wjthinkbig-internal.com",
        SOCKET_DOMAIN: "https://socket-public-broadcast-activity-dev.wjthinkbig.com",
        SAMID_WEB_DOMAIN: "https://smartall-mid-web-dev.wjthinkbig.com",
        SAMID_WEB_DOMAIN_PATH: "https://smartall-m-dev.wjthinkbig.com", // IOS 도메인
        // GW_ALLTAB_DOMAIN: "https://gw-thinkbigstudy-dev.wjthinkbig.com",

        QST_VIEWER_DOMAIN_DEV: "https://smartall-m-dev.wjthinkbig.com",
    },

    CLASS_DETAIL_VDO_INFO: "http://down.wjthinkbig.com/BOOKCLUB/SMARTALL-MID/PREVIEW/PREVIEW_CLAS_SEQ.MP4",
};
